import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './LossPropertyIncidentDetails.metadata.json5';
import styles from './LossPropertyIncidentDetails.module.scss';
import { useValidation } from 'gw-portals-validation-react';
import PropTypes from 'prop-types';

function LossPropertyIncidentDetail(props) {
    const { model, onValidate, id, onIncidentUpdates, propertyOtherDamageVM } = props;
    /*const [incidents, setIncidents] = useState(
        {
            dwellingIncident: {
                isSet: '',
                incident: false,
                description: ''
            },
            personalPropertyIncident: {
                isSet: '',
                incident: false,
                description: ''
            },
            otherStructuresIncident: {
                isSet: '',
                incident: false,
                description: ''
            },
            livingExpensesIncident: {
                isSet: '',
                incident: false,
                description: ''
            },
        });*/

    const {
        isComponentValid,
        registerComponentValidation
    } = useValidation(id);

    /*const initializeIncidentsWithModelData = useEffect(() => {
        if (model.value && model.value.length > 0 && incidents) {
            const initIncidents = _.clone(incidents);
            model.value.forEach((modleIncident) => {
                for (const [key, value] of Object.entries(initIncidents)) {
                    if (modleIncident.incident) {
                        let tempValue = value;
                        tempValue.isSet = 'true';
                        tempValue.incident = modleIncident.incident;
                        tempValue.description = modleIncident.description;
                        initIncidents[key] = tempValue;
                    }
                }
            });

            setIncidents(initIncidents);
        }
    }, []);*/

    const isIncident = useCallback(() => {
        if (
            !propertyOtherDamageVM.aspects.valid
            || !propertyOtherDamageVM.aspects.subtreeValid
        ) {
            return false;
        }
        return true;
    }, [propertyOtherDamageVM]);

    useEffect(() => {
        registerComponentValidation(isIncident);
    }, [registerComponentValidation, isIncident]);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid);
        }
    }, [id, isComponentValid, onValidate]);


    /*const handleChange = (value, path, prop) => {
        const newIncidents = _.clone(incidents);
        _.set(newIncidents, prop.dataPath, value);
        setIncidents(newIncidents);

        const _incidents = _.filter(incidents, (inc) => { return inc.isSet }).map((a, index) => {
            return {
                incident: true,
                description: a.description,
            }
        })

        model.value = _incidents

        if (onIncidentUpdates) {
            onIncidentUpdates(model.value);
        }
    }*/

    const handleValueChange = (value, path, prop) => {
    _.set(propertyOtherDamageVM, prop.dataPath, value);
        if (onIncidentUpdates) {
            onIncidentUpdates(propertyOtherDamageVM.value);
        }
    }

    /*const generateIncidentOveride = () => {
        const overrides = Object.keys(incidents).map((inc, index) => {
            return {
                [`${inc}Checkbox`]: {
                    value: _.get(incidents[inc], 'isSet'),
                    model: incidents,
                    dataPath: `${[inc]}` + '.isSet',
                    onValueChange: handleChange
                },
                [`${inc}Desc`]: {
                    value: _.get(incidents[inc], 'description'),
                    model: incidents,
                    dataPath: `${[inc]}` + '.description',
                    visible: _.get(incidents[inc], 'isSet'),
                    onValueChange: handleChange
                }
            }
        })
        return Object.assign({}, ...overrides);
    }*/

    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        /*otherDamageContainer: {
            path: incidents,
            data: incidents
        },*/
        dwellingIncidentCheckbox: {
            value: _.get(propertyOtherDamageVM.value, 'dwellingIncidents.incident'),
            dataPath: 'dwellingIncidents.incident',
            onValueChange: handleValueChange
        },
        dwellingIncidentDesc: {
            value: _.get(propertyOtherDamageVM.value, 'dwellingIncidents.description'),
            dataPath: 'dwellingIncidents.description',
            visible: propertyOtherDamageVM.dwellingIncidents.incident.value,
            onValueChange: handleValueChange
        },
        personalPropertyIncidentCheckbox: {
            value: _.get(propertyOtherDamageVM.value, 'personalPropertyIncident.incident'),
            dataPath: 'personalPropertyIncident.incident',
            onValueChange: handleValueChange
        },
        personalPropertyIncidentDesc: {
            value: _.get(propertyOtherDamageVM.value, 'personalPropertyIncident.description'),
            dataPath: 'personalPropertyIncident.description',
            visible: propertyOtherDamageVM.personalPropertyIncident.incident.value,
            onValueChange: handleValueChange
        },
        otherStructuresIncidentCheckbox: {
            value: _.get(propertyOtherDamageVM.value, 'otherStructuresIncident.incident'),
            dataPath: 'otherStructuresIncident.incident',
            onValueChange: handleValueChange
        },
        otherStructuresIncidentDesc: {
            value: _.get(propertyOtherDamageVM.value, 'otherStructuresIncident.description'),
            dataPath: 'otherStructuresIncident.description',
            visible: propertyOtherDamageVM.otherStructuresIncident.incident.value,
            onValueChange: handleValueChange
        },
        livingExpensesIncidentCheckbox: {
            value: _.get(propertyOtherDamageVM.value, 'livingExpensesIncident.incident'),
            dataPath: 'livingExpensesIncident.incident',
            onValueChange: handleValueChange
        },
        livingExpensesIncidentDesc: {
            value: _.get(propertyOtherDamageVM.value, 'livingExpensesIncident.description'),
            dataPath: 'livingExpensesIncident.description',
            visible: propertyOtherDamageVM.livingExpensesIncident.incident.value,
            onValueChange: handleValueChange
        }
       /* ...generateIncidentOveride()*/
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            model={propertyOtherDamageVM}
        />
    );
}
LossPropertyIncidentDetail.propTypes = {
    onValidate: PropTypes.func,
    id: PropTypes.string,
    model: PropTypes.object,
    propertyOtherDamageVM: PropTypes.object,
    onIncidentUpdates: PropTypes.func
};
LossPropertyIncidentDetail.defaultProps = {
    id: undefined,
    onIncidentUpdates: undefined
};
export default LossPropertyIncidentDetail;